import { Component } from "@angular/core";
import { toastrService } from "../../services/ux/toastr.service";
import { environment } from "src/environments/environment";
@Component({
  templateUrl: "./tos.component.html",
  styleUrls: ["terms-of-service.css"]
})
export class TermsOfUseComponent {
  environment: any
  constructor(public toastr: toastrService) {
    this.environment = environment
  }
}
